/* FERAL 2026 — IntersectionObserver scroll reveal.
   Adds .is-revealed to [data-feral-reveal] on first viewport entry.
   Re-scans on shopify:section:load for theme editor. */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-feral-reveal]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function scan(root) {
    (root || document).querySelectorAll('[data-feral-reveal]:not(.is-revealed)').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
        // Already in view on initial paint — reveal immediately, no flicker
        el.classList.add('is-revealed');
      } else {
        obs.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
